<template>
    <div class="row g-3 mb-4">
        <div ref="headerRef"
            class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer"
            @click="toggleSection">
            <h6 class="fw-bold mb-0">{{ title }}</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <div class="col-12" v-show="sectionCollapse">
            <div class="row g-3">

                <div class="col-12 col-md-3">
                    <label class="form-label fw-semibold small mb-1">Typ pojazdu</label>
                    <select class="form-select form-select-sm" v-model="form.vehicle.type">
                        <option value="">-- wybierz --</option>
                        <option value="osobowy">Osobowy</option>
                        <option value="dostawczy">Dostawczy</option>
                        <option value="ciezarowy">Ciężarowy</option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Marka *</label>
                    <select class="form-select form-select-sm" v-model="form.vehicle.makeID"
                        @change="$emit('makeChange', form.vehicle.makeID)" required>
                        <option :value="null">-- Wybierz markę --</option>
                        <option v-for="m in dicts.makes" :key="m.ID || m.id" :value="m.ID || m.id">{{ m.name || m.make
                            }}</option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Model *</label>
                    <select class="form-select form-select-sm" v-model="form.vehicle.modelID"
                        :disabled="!form.vehicle.makeID" required>
                        <option :value="null">-- Wybierz model --</option>
                        <option v-for="md in dicts.models" :key="md.ID || md.id" :value="md.ID || md.id">{{ md.name ||
                            md.model }}</option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Pojemność silnika (cm³)</label>
                    <input type="number" class="form-control form-control-sm" v-model="form.vehicle.engineCapacity" />
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Stan licznika (km)</label>
                    <input type="number" class="form-control form-control-sm" v-model="form.vehicle.mileage" />
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Skrzynia biegów</label>
                    <select class="form-select form-select-sm" v-model="form.vehicle.gearboxID">
                        <option :value="null">-- Wybierz skrzynię --</option>
                        <option v-for="g in dicts.gearboxes" :key="g.ID || g.id" :value="g.ID || g.id">{{ g.name }}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Typ paliwa</label>
                    <select class="form-select form-select-sm" v-model="form.vehicle.fuelTypeID">
                        <option :value="null">-- Wybierz paliwo --</option>
                        <option v-for="f in dicts.fuelTypes" :key="f.ID || f.id" :value="f.ID || f.id">{{ f.name }}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Moc (KM)</label>
                    <input type="number" class="form-control form-control-sm" v-model="form.vehicle.powerHp" />
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Kolor</label>
                    <select class="form-select form-select-sm" v-model="form.vehicle.colourID">
                        <option :value="null">-- Wybierz kolor --</option>
                        <option v-for="c in dicts.colours" :key="c.ID || c.id" :value="c.ID || c.id">{{ c.name }}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-md-6">
                    <label class="form-label small">VIN</label>
                    <input 
                        type="text" 
                        class="form-control form-control-sm text-uppercase" 
                        v-model="form.vehicle.vin"
                        maxlength="17" 
                        placeholder="17 znaków VIN" 
                        @input="form.vehicle.vin = form.vehicle.vin.toUpperCase()" 
                    />
                    
                    <!-- Walidacja VIN na żywo -->
                    <div v-if="form.vehicle.vin && form.vehicle.vin.length > 0" class="mt-1">
                        <small class="text-danger" v-if="!validateVIN(form.vehicle.vin).valid">
                            <i class="bi bi-exclamation-circle me-1"></i>{{ validateVIN(form.vehicle.vin).message }}
                        </small>
                        <small class="text-warning" v-else-if="validateVIN(form.vehicle.vin).warning">
                            <i class="bi bi-exclamation-triangle me-1"></i>{{ validateVIN(form.vehicle.vin).warning }}
                        </small>
                        <small class="text-success" v-else>
                            <i class="bi bi-check-circle me-1"></i>Poprawny format VIN
                        </small>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Numer rejestracyjny</label>
                    <input type="text" class="form-control form-control-sm text-uppercase"
                        v-model="form.vehicle.registrationPlate" />
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Rok produkcji</label>
                    <input type="number" class="form-control form-control-sm" v-model="form.vehicle.productionYear" />
                </div>
                <div class="col-12 col-md-3">
                    <label class="form-label small">Data pierwszej rejestracji</label>
                    <input type="date" class="form-control form-control-sm"
                        v-model="form.vehicle.firstRegistrationDate" />
                </div>
                <div class="col-12">
                    <label class="form-label small">Pozostałe dane / Opis</label>
                    <textarea class="form-control form-control-sm" rows="3" v-model="form.vehicle.additionalInfo"
                        placeholder="Dodatkowe informacje o pojeździe..."></textarea>
                </div>
                <div class="col-12">
                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="$emit('saveCarToOffers')">
                        <i class="bi bi-cloud-plus me-1"></i>Dodaj pojazd do bazy ofert
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue'
import { validateVIN } from '@/utils/validators'

const props = defineProps({
    modelValue: { type: Object, required: true },
    title: { type: String, default: '1. Dane pojazdu' },
    dicts: { type: Object, default: () => ({ makes: [], models: [], gearboxes: [], fuelTypes: [], colours: [] }) },
    lastDocuments: { type: Array, default: () => [] }
})
const emit = defineEmits(['update:modelValue', 'makeChange', 'saveCarToOffers'])

const headerRef = ref(null)
const sectionCollapse = ref(false)

const form = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const toggleSection = async () => {
    sectionCollapse.value = !sectionCollapse.value
    if (sectionCollapse.value) {
        await nextTick()
        headerRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}


</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>